import { render, staticRenderFns } from "./DefaultDescription.vue?vue&type=template&id=62f7de32&scoped=true"
import script from "./DefaultDescription.vue?vue&type=script&lang=ts"
export * from "./DefaultDescription.vue?vue&type=script&lang=ts"
import style0 from "./DefaultDescription.vue?vue&type=style&index=0&id=62f7de32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f7de32",
  null
  
)

export default component.exports